import mainFaqData from '../../assets/data/mainFaq.json';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import styles from './HomeMobile.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
import rightArrow from '../../assets/rightArrow.png';
import MainFaqFrameMobile from '../../mobileComponents/MainFaqFrameMobile/MainFaqFrameMobile';
import MainReviewFrame from '../../components/MainReviewFrame/MainReviewFrame';
import { IReviewDataType } from '../../pages/MyReview/MyReview';
import LazyLoad from 'react-lazy-load';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { loginCheck } from '../../auth/auth';
import ReviewFilter from '../../components/ReviewFilter/ReviewFilter';
import banner02 from '../../assets/bannerImage02.png';
import subBanner from '../../assets/banner/subBanner.png';
import processImage01 from '../../assets/processImage01.png';
import processImage02 from '../../assets/processImage02.png';
import processImage03 from '../../assets/processImage03.png';
import country01 from '../../assets/country/country1.png';
import country02 from '../../assets/country/country2.png';
import country03 from '../../assets/country/country3.png';
import country04 from '../../assets/country/country4.png';
import doctor02 from '../../assets/doctors/doctor02.png';
import youjiyou from '../../assets/doctors/youjiyou.png';
import kimmiri from '../../assets/doctors/kimmiri.png';
import star from '../../assets/star.png';
import america from '../../assets/america.png';
import { IProductListType } from '../../pages/ProductList/ProductList';
import banner from '../../assets/banner/mobileMainBanner.jpeg';
import banner2 from '../../assets/banner/mobileMainBanner02.png';
import process01 from '../../assets/process01.png';
import process02 from '../../assets/process02.png';
import process03 from '../../assets/process03.png';
import process04 from '../../assets/process04.png';
import { useTranslation } from 'react-i18next';
import Popup from '../../components/Popup/Popup';
import mobileMainBanner3 from '../../assets/banner/mobileMainBanner3.png';
import mobileMainBanner4 from '../../assets/banner/mobileMainBanner4.png';
import gambichMobile from '../../assets/banner/gambichaMobile.png';
import biumhwanMobile from '../../assets/banner/biumhwanMobile.png';
import bogamMobile from '../../assets/banner/dietProgramBanner.png';
import mobileSubBanner1 from '../../assets/banner/mobileSubBanner1.png';
import mobileSubBanner2 from '../../assets/banner/mobileSubBanner2.png';
import mobileSubBanner3 from '../../assets/banner/mobileSubBanner3.png';

const countryList = [country01, country02, country03, country04];

const imsiSliderList = [banner2];

const mainFaqList = mainFaqData;
function HomeMobile() {
  const location = useLocation();
  const navigate = useNavigate();
  //배너
  const [activeIdx, setActiveIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperCore>();
  //배너
  //상품
  const { data: productList } = useQuery<IProductListType[]>(
    ['productList', 'all'],
    async () => {
      let queryString = '';
      let ids = JSON.parse(
        sessionStorage.getItem('product_ids') || JSON.stringify([]),
      );
      if (ids.length) {
        queryString = 'add_products=';
        ids.map((id: number, idx: number) => {
          queryString += `${id}${idx !== ids.length - 1 ? ',' : ''}`;
        });
      }
      return await axiosClient
        .get(`/data/product/list?${queryString}`)
        .then((res) => res.data.data);
    },
    {
      staleTime: 60000 * 60 * 24,
    },
  );
  //상품
  //프로세스
  const [processSliderIdx, setProcessSliderIdx] = useState(0);
  //프로세스
  //faq
  // const { data: faqListQuery } = useQuery<{
  //   data: IFaqType[];
  //   faq_type: {
  //     [key: number]: string;
  //   };
  // }>('faq', () => axiosClient.get('/data/faq').then((res) => res.data.data), {
  //   staleTime: 60000 * 60 * 24, //1일 캐싱
  // });
  //faq
  //review
  // const [reviewData, setReviewData] = useState<IReviewDataType[]>([]);
  // useEffect(() => {
  //   axiosClient
  //     .get('/data/product_talk/list?&talk_type=상품평가&limit=5&order_by=star')
  //     .then((res) => setReviewData(res.data.data));
  // }, []);
  const { data: reviewData } = useQuery<IReviewDataType[]>(
    ['main', 'photo_review'],
    () =>
      axiosClient
        .get(
          '/data/product_talk/photo-review-list?&talk_type=상품평가&limit=5&order_by=star',
        )
        .then((res) => res.data.data),
    {
      staleTime: 60000 * 60,
    },
  );
  //review
  //doctor
  const [doctorSliderIdx, setDoctorSliderIdx] = useState(0);
  //doctor

  //기존 상품 url접속시 대응
  useEffect(() => {
    let pn = new URLSearchParams(location.search).get('pn');
    if (!pn) return;
    if (pn == 'product.view') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=N&code=${new URLSearchParams(
            location.search,
          ).get('pcode')}`,
        )
        .then((res) => navigate(res.data.data.url));
    } else if (pn == 'blind_gate') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=Y&code=${new URLSearchParams(
            location.search,
          ).get('bc')}`,
        )
        .then((res) => navigate(res.data.data.url));
    }
  }, []);
  //기존 상품 url접속시 대응
  const { t, i18n } = useTranslation();
  
  const productsInfo = [
    {
      name: "Cheongdam Bogam <br /> Diet tablet",
      description: "Cheongdam Bogam to lose <br /> weight for a short period of <br /> time a quick diet program. <br /> <br /> A healthy diet in which you <br /> can succeed at once while <br /> taking care of your health.",
      url: bogamMobile,
    },
    {
      name: "Cheongdam Bogam <br /> Gambi Tea",
      description: "Seven carefully selected <br /> herbal ingredients  by experts <br /> in Ondoc. <br /> <br /> Cleanse your daily life gently <br /> with nature’s finest ingredients.",
      url: gambichMobile,
    },
    {
      name: "Cheongdam Bogam <br /> Bium Hwan",
      description: "A healthy twice-daily habit. <br /> <br /> Empower your everyday with <br /> natural vitality.",
      url: biumhwanMobile,
    }
  ];
  return (
    <div>
      <Header />
      {/* <Popup /> */}
      <div className={styles.bannerSliderWrap}>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView={1}
          spaceBetween={0}
          className={styles.bannerSlider}
          onSlideChange={(e) => setActiveIdx(e.activeIndex)}
        >
          {imsiSliderList.map((banner, idx) => (
            <SwiperSlide key={idx}>
              <img src={banner} alt="banner" onClick={() => navigate('/productList')}/>
            </SwiperSlide>
          ))}
        </Swiper>
        <ul className={styles.paginationWrap}>
          {imsiSliderList.map((banner, idx) => (
            <li
              key={idx}
              onClick={() => swiper?.slideTo(idx, 200)}
              className={idx == activeIdx ? styles.hit : ''}
            ></li>
          ))}
        </ul>
      </div>
      {/* <div className={styles.processInfoWrap}>
        <h3>{t('home.1')}</h3>
        <p>{t('home.2')}</p>
        <ul>
          <li># {t('home.3')}</li>
          <li># {t('home.5')}</li>
          <li># {t('home.4')}</li>
        </ul>
        <div className={styles.processSliderWrap}>
          <Swiper
            slidesPerView={1}
            spaceBetween={21}
            className={styles.processSlider}
            onSlideChange={(e) => setProcessSliderIdx(e.activeIndex)}
          >
            <SwiperSlide className={styles.processSlide}>
              <img src={process01} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.6')}</h4>
                <p>{t('home.7')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process02} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.8')}</h4>
                <p>{t('home.9')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process03} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.10')}</h4>
                <p>{t('home.11')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process04} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.12')}</h4>
                <p>{t('home.13')}</p>
              </div>
            </SwiperSlide>
          </Swiper>
          <ul className={styles.processSliderPagination}>
            {(() => {
              let list = [0, 1, 2, 3];
              return list.map((val) => (
                <li
                  key={val}
                  className={processSliderIdx == val ? styles.hit : ''}
                >
                  <div></div>
                </li>
              ));
            })()}
          </ul>
        </div>
      </div> */}
      {/*<div className={styles.worldPlatform}>*/}
      {/*  <h3*/}
      {/*    dangerouslySetInnerHTML={{*/}
      {/*      __html: t('home.59').replace(/<br \/>/gi, ''),*/}
      {/*    }}*/}
      {/*  ></h3>*/}
      {/*  <ul>*/}
      {/*    {countryList.map((country, idx) => (*/}
      {/*      <li key={idx}>*/}
      {/*        <img src={country} />*/}
      {/*      </li>*/}
      {/*    ))}*/}
      {/*  </ul>*/}
      {/*  <p>{t('home.60')}</p>*/}
      {/*</div>*/}
      {/* <div className={styles.prescriptionProductWrap}>
        <h3 onClick={() => navigate(`/productList?cuid=487`)}>
          <span>{t('home.14')}</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.15')}</span>
        <Swiper
          slidesPerView={1.1}
          spaceBetween={10}
          className={styles.prescriptionProductSlider}
        >
          {productList
            ?.filter((product) => product.is_prescription == 1)
            .map((product) => (
              <SwiperSlide
                key={product.product_id}
                className={styles.prescriptionProductSlide}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <img src={product.list_image} alt="productThumbnail" />
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  <ul className={styles.hashtagList}>
                    {product.hashtag &&
                      product.hashtag
                        .split(',')
                        .map((hashtag) => <li># {hashtag}</li>)}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <div className={styles.normalProductWrap}>
        <h3 onClick={() => navigate(`/productList?cuid=488`)}>
          <span>{t('home.16')}</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.17')}</span>
        <ul className={styles.normalProductList}>
          {productList
            ?.filter((product) => product.is_prescription == 0)
            .filter((product, idx) => idx == 0)
            .map((product) => (
              <li
                key={product.product_id}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <div className={styles.productThumbnailWrap}>
                  <img src={product.list_image} alt="productThumbnail" />
                </div>
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  <ul className={styles.hashtagList}>
                    {product.hashtag &&
                      product.hashtag
                        .split(',')
                        .map((hashtag, idx) => <li key={idx}>{hashtag}</li>)}
                  </ul>
                </div>
              </li>
            ))}
        </ul>
      </div> */}
      <div className={styles.middleBanner}>
        <div className={styles.bannerItem}>
          <h2>$35M</h2>
          <p>In research and <br /> development</p>
        </div>
        <div className={styles.bannerItem}>
          <h2>100+</h2>
          <p>Global patents on <br /> our nutrition technology</p>
        </div>
        <div className={styles.bannerItem}>
          <h2>32</h2>
          <p>Clinical trials - <br /> science you can trust</p>
        </div>
        <div className={styles.bannerItem}>
          <h2>16</h2>
          <p>Prestigious University <br /> research partners</p>
        </div>
      </div>
      <div className={styles.infoSliderWrap}>
        <Swiper
          slidesPerView={1.5}
          spaceBetween={11}
          className={styles.infoSlider}
          pagination={{ clickable: true }}
        >
          <SwiperSlide className={styles.infoSlide}>
            <div className={styles.imageWrap}>
              <img src={mobileMainBanner3} alt="Mobile Main Banner3" />
              <div className={styles.textOverlay}>
                <h2>
                  Ondoc offers <br /> trusted care, <br /> rooted in nature
                </h2>
                <p>
                  We blend time-honored herbal <br /> wisdom with modern science to <br /> bring you
                  natural wellness solutions <br /> that fit your lifestyle.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className={styles.infoSlide}>
            <div className={styles.imageWrap}>
              <img src={mobileMainBanner4} alt="Mobile Main Banner4" />
              <div className={styles.textOverlay}>
                <h2>
                  Ondoc prescribes <br /> korean medicine <br /> in many countries
                </h2>
                <p>
                  The United States, Thailand, <br /> Australia, Arab countries, etc. <br /> Support for international services in <br /> six countries.
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className={styles.allProductList}>
        <h3>ONDOC PRODUCT</h3>
        <ul className={styles.productListWrap}>
          {(() => {
            const featuredIds = [45, 11, 10];
            return productList
              ?.map((product) => {
                const displayIdx = featuredIds.indexOf(product.product_id);
                if (displayIdx === -1) return null;
                const content = productsInfo[displayIdx];
                if (!content) return null;

                return (
                  <li
                    key={product.product_id}
                    className={`${styles.productCard} ${
                      displayIdx === 1 ? styles.reverseLayout : ""
                    }`}
                  >
                    <div className={styles.mainImageWrap}>
                      <img src={content.url} alt="mainProductImage" />
                    </div>
                    <div className={styles.productInfoSection}>
                      <div className={styles.productThumbnailWrap}>
                        <img
                          src={product.list_image + '?w=530'}
                          alt="productThumbnail"
                        />
                      </div>
                      <div className={styles.productDetails}>
                        <h3
                          className={styles.productTitle}
                          dangerouslySetInnerHTML={{ __html: content.name }}
                        />
                        <p dangerouslySetInnerHTML={{ __html: content.description }} />
                        <span className={styles.price}>
                          ${product.discount_price.toLocaleString()}
                        </span>
                        <button
                          className={styles.shopNowButton}
                          onClick={() => navigate(`/productDetail/${product.product_id}`)}
                        >
                          Shop Now
                        </button>
                      </div>
                    </div>
                  </li>
                );
              })
          })()}
        </ul>
        {productList && productList.length > 4 && (
          <button onClick={() => navigate(`/productList`)}>
            See More Products
          </button>
        )}
      </div>
      {/* <div className={styles.freeShippingSection}>
        <p>Free Shipping on <br /> orders $70+</p>
      </div> */}
      <div className={styles.infoSliderWrap}>
        <Swiper
          slidesPerView={1.5}
          spaceBetween={11}
          className={styles.infoSlider}
          pagination={{ clickable: true }}
        >
          <SwiperSlide className={styles.infoSlide}>
            <div className={styles.imageWrap}>
              <img src={mobileSubBanner1} alt="Mobile Sub Banner1" />
              <div className={styles.textOverlay}>
                <h2>
                  Carefully <br /> Processed
                </h2>
                <p>
                Advanced techniques preserve <br />
                the full benefits of each herb.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className={styles.infoSlide}>
            <div className={styles.imageWrap}>
              <img src={mobileSubBanner2} alt="Mobile Sub Banner2" />
              <div className={styles.textOverlay}>
                <h2>
                  Sourced <br /> from Nature
                </h2>
                <p>
                High-quality herbs, handpicked <br />
                from nature’s finest sources.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className={styles.infoSlide}>
            <div className={styles.imageWrap}>
              <img src={mobileSubBanner3} alt="Mobile Sub Banner3" />
              <div className={styles.textOverlay}>
                <h2>
                  Delivered for <br /> Wellness
                </h2>
                <p>
                Convenient, ready-to-use products <br />
                for a balanced, healthy life.
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className={styles.faqWrap}>
        <h3 onClick={() => navigate(`/faq`)}>
          <span>ONDOC FAQ</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <ul>
          {mainFaqList.map((faq, idx) => (
            <MainFaqFrameMobile faq={faq} key={idx} />
          ))}
        </ul>
      </div>
      <div className={styles.reviewWrap}>
        <h3 onClick={() => navigate(`/review/all`)}>
          <span>LIVE REVIEW</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <div className={styles.reviewSliderWrap}>
          <LazyLoad>
            <Swiper
              slidesPerView={1.2}
              spaceBetween={10}
              className={styles.reviewSlider}
              breakpoints={{ 700: { slidesPerView: 2.8 } }}
            >
              {reviewData
                ?.filter((review) => review.product?.list_image)
                .map((review) => (
                  <SwiperSlide key={review.id}>
                    <MainReviewFrame review={review} />
                  </SwiperSlide>
              ))}
            </Swiper>
          </LazyLoad>
          {/* {!loginCheck() && <ReviewFilter borderRadius={0} />} */}
        </div>
      </div>
      {/* <div className={styles.ondocInfoWrap}>
        <ul>
          <li>
            <h3>{t('home.22')}</h3>
            <p>{t('home.23')}</p>
            <img src={processImage01} alt="processImage" />
          </li>
          <li>
            <h3>{t('home.24')}</h3>
            <p>{t('home.25')}</p>
            <img src={processImage02} alt="processImage" />
          </li>
          <li>
            <h3>{t('home.26')}</h3>
            <p>{t('home.27')}</p>
            <img src={processImage03} alt="processImage" />
          </li>
        </ul>
      </div> */}
      {/*<div className={styles.legitScript}>*/}
      {/*  <img src={america} alt="america" />*/}
      {/*  <div>*/}
      {/*    <img*/}
      {/*      src="  https://static.legitscript.com/seals/14145209.png"*/}
      {/*      alt="legit"*/}
      {/*    />*/}
      {/*    <p>{t('home.58')}</p>*/}
      {/*    <p>*/}
      {/*      Ondoc started with US legitScript*/}
      {/*      <br />*/}
      {/*      contactless medical certification has been obtained.*/}
      {/*    </p>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className={styles.doctorInfoWrap}>
        <h3>ONDOC DOCTORS</h3>
        <div className={styles.doctorSliderWrap}>
          <Swiper
            slidesPerView={1}
            spaceBetween={21}
            className={styles.doctorSlider}
            onSlideChange={(e) => setDoctorSliderIdx(e.activeIndex)}
          >
            <SwiperSlide className={styles.doctorSlide}>
              <div className={styles.doctorImageWrap}>
                <img src={doctor02} alt="process" />
              </div>
              <div className={styles.doctorInfo}>
                <h4>{t('home.29')}</h4>
                <ul>
                  <li>{t('home.30')}</li>
                  <li>{t('home.31')}</li>
                  <li>{t('home.32')}</li>
                  <li>{t('home.33')}</li>
                  <li>{t('home.34')}</li>
                  <li>{t('home.35')}</li>
                  <li>{t('home.36')}</li>
                </ul>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.doctorSlide}>
              <div className={styles.doctorImageWrap}>
                <img
                  src={youjiyou}
                  alt="process"
                  style={{ maxWidth: '151px' }}
                />
              </div>
              <div className={styles.doctorInfo}>
                <h4>{t('home.37')}</h4>
                <span>Yoo jiyou</span>
                <ul>
                  <li>{t('home.38')}</li>
                  <li>{t('home.39')}</li>
                  <li>{t('home.40')}</li>
                  <li>{t('home.41')}</li>
                  <li>{t('home.42')}</li>
                </ul>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.doctorSlide}>
              <div className={styles.doctorImageWrap}>
                <img
                  src={kimmiri}
                  alt="process"
                  style={{
                    maxWidth: '183px',
                    objectPosition: 'top',
                  }}
                />
              </div>
              <div className={styles.doctorInfo}>
                <h4>{t('home.43')}</h4>
                <span>Kim miri</span>
                <ul>
                  <li>{t('home.44')}</li>
                  <li>{t('home.45')}</li>
                  <li>{t('home.46')}</li>
                  <li>{t('home.47')}</li>
                  <li>{t('home.48')}</li>
                </ul>
              </div>
            </SwiperSlide>
          </Swiper>
          <ul className={styles.doctorSliderPagination}>
            {(() => {
              let list = [0, 1, 2];
              return list.map((val) => (
                <li
                  key={val}
                  className={doctorSliderIdx == val ? styles.hit : ''}
                >
                  <div></div>
                </li>
              ));
            })()}
          </ul>
        </div>
      </div>
      <div className={styles.ondocService}>
        <img src={banner02} alt="banner" />
        <div className={styles.textWrap}>
          <p dangerouslySetInnerHTML={{ __html: t('home.56') }}></p>
          <p dangerouslySetInnerHTML={{ __html: t('home.57') }}></p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default HomeMobile;

